import client from './client';

export type InvestorUserRole = 'viewer' | 'admin';

export interface InvestorUserListItem {
  investor_user_id: number;
  investor_user_uuid_id: string;
  investor_id: number;
  investor_uuid_id: string;
  investor_name: string;
  full_name: string | null;
  email: string;
  role: InvestorUserRole;
  status: number;
  last_login_at: string | null;
  created_at: string;
}

export interface InvestorUserPayload {
  investor_uuid_id: string;
  full_name: string;
  email: string;
  password?: string;
  role: InvestorUserRole;
  status: number;
}

export async function fetchInvestorUsers(): Promise<InvestorUserListItem[]> {
  const res = await client.get<InvestorUserListItem[]>('/investor-users');
  return res.data;
}

export async function createInvestorUser(data: InvestorUserPayload): Promise<{ investor_user_uuid_id: string }> {
  const res = await client.post<{ investor_user_uuid_id: string }>('/investor-users', data);
  return res.data;
}

export async function updateInvestorUser(uuidId: string, data: InvestorUserPayload): Promise<void> {
  await client.put(`/investor-users/${uuidId}`, data);
}

export async function deleteInvestorUser(uuidId: string): Promise<void> {
  await client.delete(`/investor-users/${uuidId}`);
}
